export default [
  { name: 'Australian Capital Territory', code: 'ACT' },
  { name: 'New South Wales', code: 'NSW' },
  { name: 'Northern Territory', code: 'NT' },
  { name: 'Queensland', code: 'QLD' },
  { name: 'South Australia', code: 'SA' },
  { name: 'Tasmania', code: 'TAS' },
  { name: 'Victoria', code: 'VIC' },
  { name: 'Western Australia', code: 'WA' }
];
